import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  &.center {
    justify-content: center;
  }

  &.right {
    justify-content: flex-end;
  }
  &.spaceBetween {
    justify-content: space-between;
  }
`;

interface ModalFooterContentStylesProps {
  align?: 'left' | 'center' | 'right' | 'spaceBetween';
  content?: React.ReactNode;
}

export const ModalFooterContentStyles = (props: ModalFooterContentStylesProps) => {
  const { align = 'left', content } = props;

  return <Container className={cl('modal-footer-content-styles', align)}>{content}</Container>;
};
